/**
 * GetHubsPayload created by karora on 29/03/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from "../app.component";
import {Router} from "@angular/router";

/*
    [{
      "battery_temp":30,
      "bias":-1.7,
      "boiler":true,
      "charging":false,
      "cpu_temp":49.8,
      "created":"2017-12-09T17:22:22.373Z",
      "current":-1,
      "gap":197,
      "heating":1,
      "holiday":false,
      "hubid":196,
      "humidity":42.85,
      "last_on_1":57,
      "last_on_2":7,
      "last_on_3":16,
      "last_on_4":14,
      "last_success":196,
      "mains":null,
      "major":0,
      "minor":6,
      "patch":44,
      "raw_temp":22.28,
      "reset1":0,
      "reset2":0,
      "reset3":0,
      "rssi":-57,
      "setpoint":21.2,
      "temperature":20.58,
      "touched":false,
      "uid":12983785,
      "uptime":614685,
      "voltage":4194,
      "wifi_version":3030008,
      "wires":3
    },{
      "battery_temp":0,
      "bias":-0.9,
      "boiler":false,
      "charging":false,
      "cpu_temp":0,
      "created":"2017-12-09T17:20:59.840Z",
      "current":0,
      "gap":28,
      "heating":0,
      "holiday":false,
      "hubid":1116,
      "humidity":79.59,
      "last_on_1":19,
      "last_on_2":9,
      "last_on_3":12,
      "last_on_4":10,
      "last_success":-91,
      "mains":null,
      "major":2,
      "minor":0,
      "patch":0,
      "raw_temp":24.69,
      "reset1":-91,
      "reset2":-91,
      "reset3":-91,
      "rssi":0,
      "setpoint":21,
      "temperature":23.79,
      "touched":false,
      "uid":12983725,
      "uptime":374311,
      "voltage":3171,
      "wifi_version":0,
      "wires":0
    }]
*/

class gotHub {
  battery_temp: number;
  bias:number;
  boiler:boolean;
  charging:boolean;
  cpu_temp:number;
  created:string;
  current:number;
  gap:number;
  heating:number;
  holiday:boolean;
  hubid:number;
  humidity:number;
  last_on_1:number;
  last_on_2:number;
  last_on_3:number;
  last_on_4:number;
  last_success:number;
  mains:boolean;
  major:number;
  minor:number;
  patch:number;
  raw_temp:number;
  reset1:number;
  reset2:number;
  reset3:number;
  rssi:number;
  setpoint:number;
  temperature:number;
  touched:boolean;
  uid:number;
  uptime:number;
  voltage:number;
  wifi_version:number;
  wires:number;
}

@Component({
  selector: 'gethubs-payload',
  template: `
    <div id="gethubs" *ngIf="payload && payload != '[]'">
      <li *ngFor="let _hub of gotHubs" (click)="gotoHub(_hub.hubid)" class="hubrow">
        <div>
          <span class="hubid_prompt">Hub:</span><span class="hubid">{{_hub.hubid}}</span>
          <span class="prompt">Set:</span><span class="setpoint">{{_hub.setpoint}}</span>
          <span class="prompt">Room:</span><span class="roomtemp">{{_hub.temperature}}</span>
          <span class="prompt">Heat:</span><span class="heating">{{_hub.heating | heatingState}}</span>
          <span class="prompt">RSSI:</span><span class="rssi">{{_hub.rssi}}</span>
        </div>
      </li>
    </div>`,
  styles: [
    'span { color: black; display: inline-block;}',
    '.hubrow {width: 100%; display: block}',
    '.hubrow:hover { background-color: bisque}',
    '.hubid_prompt { font-weight: lighter; width: 2.2em; color: #444444;}',
    '.prompt { font-weight: lighter; width: 3em; color: #444444;}',
    '.hubid { font-weight: bold; width: 3em; text-align: right;}',
    '.roomtemp, .setpoint {width: 3em; }',
    '.heating { width: 3em; }',
    '.rssi { width: 3em; }'
  ]
})

export class GetHubsPayloadComponent implements OnInit {
  @Input() payload: any;
  gotHubs: gotHub[];
  errorMessage: string;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) return;
    this.gotHubs = <gotHub[]>this.payload;
  }

  gotoHub(hubid: Number): void {
    this.router.navigate(['/hub', hubid]);
  }
}
